import Panel from "@ui/panel/Panel";
import { ICellFactoryResult } from "@ui/table/Table";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";

type TOrder<T> = keyof T | "__itemType" | "__actions";
interface TItemPopupProps<T> {
	onSelected: (items?: T[]) => void;
	onClose: () => void;
	items: T[];
	multi: boolean;
	title: string;
	searchable: boolean;
	selectedItems?: T[];
	comparator?: (a: T, b: T) => boolean;
	order?: TOrder<T>[];
	gridColumns?: string;
	itemType?: string;
	cellFactory?: (
		row: T,
		cell: any,
		index: number,
		key?: number,
		name?: string,
		sx?: React.CSSProperties,
		expanded?: boolean,
		rowID?: string
	) => ICellFactoryResult;
}

export const S_SELECT_ITEMS_POPUP = new Signal<TItemPopupProps<any> | null>("S_SELECT_ITEMS_POPUP");

export const SelectItemsPopup = () => {
	const request = S_SELECT_ITEMS_POPUP.use();
	const [, setItems] = useState<(any & { selected: boolean })[] | undefined>();
	const [, setSelected] = useState<number>(0);

	useEffect(() => {
		if (request) {
			setItems(
				request.items.map(i => {
					return { ...i, selected: false };
				})
			);
		}
	}, [request]);

	if (!request) return null;

	const closePopup = () => {
		setSelected(0);
		request.onClose();
		S_SELECT_ITEMS_POPUP.invoke(null);
	};

	return (
		<Panel label={request.title} onClose={closePopup} decorator="absolute">
			123
		</Panel>
	);

	/*<Panel label={request.title} onClose={closePopup} decorator="absolute">
			
			{items && items.map((item, index) => {
					return <div>123</div>
				}}

				<Spacer size="20px" />
				<HBox gap="10px">
					<Spacer grow />
					<Button
						variant="secondarySmall"
						title="Cancel"
						onClick={() => {
							closePopup();
						}}
					/>
					<Button
						variant="primarySmall"
						title={selected > 0 ? `Add (${selected})` : "Close"}
						onClick={() => {
							request.onSelected(items?.filter(i => i.selected));
							closePopup();
						}}
					/>
				</HBox>
			</VBox>
		</Panel>
	);*/
};
